export enum WindowFunction {
  NONE = 'NONE',
  RATIO_TO_REPORT = 'RATIO_TO_REPORT',
}

export enum AggregateFunction {
  SUM = 'SUM',
  AVG = 'AVG',
  COUNT = 'COUNT',
}

export enum MathOperator {
  MIN = 'MIN',
  MAX = 'MAX',
}

export type CustomColumnType = {
  id: string;
  name: string;
  formula: string;
  dependency: string[];
  windowFunction?: WindowFunction;
};
